import { Close, Visibility } from "@mui/icons-material";
import { Chip, Dialog, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import TaskView from "../tasks/TaskView";
import { Task } from "../../../app/backendTypes";

export default function PendingAction(props: {
  task: Task;
  callback: () => void;
  onCompleted: () => void;
}) {
  const { task, callback, onCompleted } = props;

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (task.status.kind === "Done" || task.status.kind === "Cancelled")
      onCompleted();
  }, [onCompleted, task]);

  return (
    <>
      <Chip
        icon={<Visibility />}
        label="Pending"
        color="warning"
        variant="outlined"
        onClick={() => setOpen(true)}
      />
      <Dialog open={open}>
        <TaskView
          task={task}
          callback={() => {
            callback();
            setOpen(false);
          }}
          expanded
          close={
            <IconButton onClick={() => setOpen(false)}>
              <Close />
            </IconButton>
          }
        />
      </Dialog>
    </>
  );
}
